import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Heading, Container, Text } from '@leroy-merlin-br/backyard-react-ui'

const sortersBarStyles = ({ theme }) => css`
  label: sorters-bar;

  padding-top: ${theme.spacings.kilo};
  padding-bottom: ${theme.spacings.kilo};

  margin-bottom: ${theme.spacings.mega};
`

const wrapperStyles = ({ theme }) => css`
  label: sorters-bar__wrapper;

  display: grid;
  grid-template-columns: repeat(4, auto) 1fr;
  align-items: center;
  column-gap: ${theme.spacings.kilo};
`

const WrapperEndStyles = () => css`
  label: sorters-bar__wrapper-end;

  justify-self: end;
`

const titleStyles = ({ theme }) => css`
  label: sorters-bar__title;

  color: ${theme.colors.n900};
`

const labelStyles = ({ theme }) => css`
  label: sorters-bar__label;

  display: flex;
  align-items: center;

  color: ${theme.colors.n900};
  font-size: ${theme.typography.headings.mega.fontSize};
  line-height: ${theme.typography.headings.mega.lineHeight};
  font-weight: ${theme.font.weight.regular};
`

const dividerStyles = ({ theme }) => css`
  label: sorters-bar__divider;

  height: 16px;
  width: 2px;

  background-color: ${theme.colors.n900};
`

const countStyles = ({ theme }) => css`
  label: sorters-bar__count;

  color: ${theme.colors.p600};

  margin-right: ${theme.spacings.bit};
`

const offersLabelStyles = ({ theme }) => css`
  label: toggle-button__label;

  font-weight: ${theme.font.weight.semibold};

  color: ${theme.colors.p600};
`

export const SortersBar = styled(Container)(sortersBarStyles)
export const Wrapper = styled('div')(wrapperStyles)
export const WrapperEnd = styled('div')(WrapperEndStyles)
export const Title = styled(Heading)(titleStyles)
export const Label = styled('span')(labelStyles)
export const Divider = styled('span')(dividerStyles)
export const Count = styled('span')(countStyles)
export const OffersLabel = styled(Text)(offersLabelStyles)
